import { Component } from "@angular/core";

@Component({
	selector: "app-private-privacy",
	templateUrl: "./private-privacy.component.html",
	styleUrl: "./private-privacy.component.scss",
	standalone: false
})
export class PrivatePrivacyComponent /* implements OnInit */ {
	// privacy: any;
	// market: any;

	/* constructor(
		public wcmService: WcmService,
		public translate: TranslateService,
		private storageService: StorageManagerService
	) { }
		this.translate.onLangChange.subscribe(
			(event: LangChangeEvent) => {
				this.setData(event.lang);
			}
		);
		userService.getProfileOfLoggedUser()
			.pipe(take(1))
			.subscribe(user => {
				this.market = user.idMarket;
			});
	} */

	/* ngOnInit() {
		this.setData();
	} */
	// TODO: qui si ignora il parametro e a ogni cambiamento di lingua si ignora il valore aggiornato e si tiene quello pescato all'inizio
	/* 	private setData(lang?: string) {
			this.wcmService
				.getWcmPrivacy(this.market.toLowerCase())
				.subscribe(value => {
					this.privacy = value;
				});
		} */
}